import React, { useState, useEffect } from 'react';
import {useApplicationContext} from '../../../provider'
import {fetchContent} from "../../product-layout/utils";
import {navigate} from 'gatsby'

const LanguagePicker = ({context}) => {

    const [loaded, setLoaded] = useState(false)
    const [sdkPicker, setSdkPicker] = useState(null)
    const { handleBarCompiler } = useApplicationContext()
    const rawTemplate = require(`raw-loader!../../../braintree/templates/partials/sdk_picker_ui.hbs`)
    useEffect(()=>{
        (async function () {
          
          // eslint-disable-next-line react-hooks/rules-of-hooks
          //TODO:: move the template to config and pass config as props
          const content = await fetchContent(rawTemplate, handleBarCompiler, context)
          setSdkPicker(content)
          setLoaded(true);
      })();
      }, [context]);

    useEffect(()=>{
        if(loaded){
            window.BTBaseLib.setupSdkPicker(navigate)
            setLoaded(false)
        }
    },[loaded])

      return (
        <>
          <div dangerouslySetInnerHTML={{__html: sdkPicker}} /> 
        </>
      );
}
  
export default LanguagePicker;